import { Country } from "./model/country.model";

export const codes = [
  {"name": "Afghanistan", "code": "AF", "iso3Code": "AFG", "dial_code": "+93"},
  {"name": "Åland Islands", "code": "AX", "iso3Code": "ALA", "dial_code": "+358"},
  {"name": "Albania", "code": "AL", "iso3Code": "ALB", "dial_code": "+355"},
  {"name": "Algeria", "code": "DZ", "iso3Code": "DZA", "dial_code": "+213"},
  {"name": "American Samoa", "code": "AS", "iso3Code": "ASM", "dial_code": "+1684"},
  {"name": "Andorra", "code": "AD", "iso3Code": "AND", "dial_code": "+376"},
  {"name": "Angola", "code": "AO", "iso3Code": "AGO", "dial_code": "+244"},
  {"name": "Anguilla", "code": "AI", "iso3Code": "AIA", "dial_code": "+1264"},
  {"name": "Antarctica", "code": "AQ", "iso3Code": "ATA", "dial_code": "+672"},
  {"name": "Antigua and Barbuda", "code": "AG", "iso3Code": "ATG", "dial_code": "+1268"},
  {"name": "Argentina", "code": "AR", "iso3Code": "ARG", "dial_code": "+54"},
  {"name": "Armenia", "code": "AM", "iso3Code": "ARM", "dial_code": "+374"},
  {"name": "Aruba", "code": "AW", "iso3Code": "ABW", "dial_code": "+297"},
  {"name": "Australia", "code": "AU", "iso3Code": "AUS", "dial_code": "+61"},
  {"name": "Austria", "code": "AT", "iso3Code": "AUT", "dial_code": "+43"},
  {"name": "Azerbaijan", "code": "AZ", "iso3Code": "AZE", "dial_code": "+994"},
  {"name": "Bahamas", "code": "BS", "iso3Code": "BHS", "dial_code": "+1242"},
  {"name": "Bahrain", "code": "BH", "iso3Code": "BHR", "dial_code": "+973"},
  {"name": "Bangladesh", "code": "BD", "iso3Code": "BGD", "dial_code": "+880"},
  {"name": "Barbados", "code": "BB", "iso3Code": "BRB", "dial_code": "+1246"},
  {"name": "Belarus", "code": "BY", "iso3Code": "BLR", "dial_code": "+375"},
  {"name": "Belgium", "code": "BE", "iso3Code": "BEL", "dial_code": "+32"},
  {"name": "Belize", "code": "BZ", "iso3Code": "BLZ", "dial_code": "+501"},
  {"name": "Benin", "code": "BJ", "iso3Code": "BEN", "dial_code": "+229"},
  {"name": "Bermuda", "code": "BM", "iso3Code": "BMU", "dial_code": "+1441"},
  {"name": "Bhutan", "code": "BT", "iso3Code": "BTN", "dial_code": "+975"},
  {"name": "Bolivia", "code": "BO", "iso3Code": "BOL", "dial_code": "+591"},
  {"name": "Bosnia and Herzegovina", "code": "BA", "iso3Code": "BIH", "dial_code": "+387"},
  {"name": "Botswana", "code": "BW", "iso3Code": "BWA", "dial_code": "+267"},
  {"name": "Brazil", "code": "BR", "iso3Code": "BRA", "dial_code": "+55"},
  {"name": "Brunei", "code": "BN", "iso3Code": "BRN", "dial_code": "+673"},
  {"name": "Bulgaria", "code": "BG", "iso3Code": "BGR", "dial_code": "+359"},
  {"name": "Burkina Faso", "code": "BF", "iso3Code": "BFA", "dial_code": "+226"},
  {"name": "Burundi", "code": "BI", "iso3Code": "BDI", "dial_code": "+257"},
  {"name": "Cambodia", "code": "KH", "iso3Code": "KHM", "dial_code": "+855"},
  {"name": "Cameroon", "code": "CM", "iso3Code": "CMR", "dial_code": "+237"},
  {"name": "Canada", "code": "CA", "iso3Code": "CAN", "dial_code": "+1"},
  {"name": "Cape Verde", "code": "CV", "iso3Code": "CPV", "dial_code": "+238"},
  {"name": "Cayman Islands", "code": "KY", "iso3Code": "CYM", "dial_code": "+1345"},
  {"name": "Central African Republic", "code": "CF", "iso3Code": "CAF", "dial_code": "+236"},
  {"name": "Chad", "code": "TD", "iso3Code": "TCD", "dial_code": "+235"},
  {"name": "Chile", "code": "CL", "iso3Code": "CHL", "dial_code": "+56"},
  {"name": "China", "code": "CN", "iso3Code": "CHN", "dial_code": "+86"},
  {"name": "Colombia", "code": "CO", "iso3Code": "COL", "dial_code": "+57"},
  {"name": "Comoros", "code": "KM", "iso3Code": "COM", "dial_code": "+269"},
  {"name": "Congo", "code": "CG", "iso3Code": "COG", "dial_code": "+242"},
  {"name": "Democratic Republic of the Congo", "code": "CD", "iso3Code": "COD", "dial_code": "+243"},
  {"name": "Costa Rica", "code": "CR", "iso3Code": "CRI", "dial_code": "+506"},
  {"name": "Côte d'Ivoire", "code": "CI", "iso3Code": "CIV", "dial_code": "+225"},
  {"name": "Croatia", "code": "HR", "iso3Code": "HRV", "dial_code": "+385"},
  {"name": "Cuba", "code": "CU", "iso3Code": "CUB", "dial_code": "+53"},
  {"name": "Cyprus", "code": "CY", "iso3Code": "CYP", "dial_code": "+357"},
  {"name": "Czech Republic", "code": "CZ", "iso3Code": "CZE", "dial_code": "+420"},
  {"name": "Denmark", "code": "DK", "iso3Code": "DNK", "dial_code": "+45"},
  {"name": "Djibouti", "code": "DJ", "iso3Code": "DJI", "dial_code": "+253"},
  {"name": "Dominica", "code": "DM", "iso3Code": "DMA", "dial_code": "+1767"},
  {"name": "Dominican Republic", "code": "DO", "iso3Code": "DOM", "dial_code": "+1"},
  {"name": "Ecuador", "code": "EC", "iso3Code": "ECU", "dial_code": "+593"},
  {"name": "Egypt", "code": "EG", "iso3Code": "EGY", "dial_code": "+20"},
  {"name": "El Salvador", "code": "SV", "iso3Code": "SLV", "dial_code": "+503"},
  {"name": "Estonia", "code": "EE", "iso3Code": "EST", "dial_code": "+372"},
  {"name": "Ethiopia", "code": "ET", "iso3Code": "ETH", "dial_code": "+251"},
  {"name": "Finland", "code": "FI", "iso3Code": "FIN", "dial_code": "+358"},
  {"name": "France", "code": "FR", "iso3Code": "FRA", "dial_code": "+33"},
  {"name": "Germany", "code": "DE", "iso3Code": "DEU", "dial_code": "+49"},
  {"name": "Ghana", "code": "GH", "iso3Code": "GHA", "dial_code": "+233"},
  {"name": "Greece", "code": "GR", "iso3Code": "GRC", "dial_code": "+30"},
  {"name": "Greenland", "code": "GL", "iso3Code": "GRL", "dial_code": "+299"},
  {"name": "Grenada", "code": "GD", "iso3Code": "GRD", "dial_code": "+1473"},
  {"name": "Guam", "code": "GU", "iso3Code": "GUM", "dial_code": "+1671"},
  {"name": "Guatemala", "code": "GT", "iso3Code": "GTM", "dial_code": "+502"},
  {"name": "Guinea", "code": "GN", "iso3Code": "GIN", "dial_code": "+224"},
  {"name": "Guyana", "code": "GY", "iso3Code": "GUY", "dial_code": "+592"},
  {"name": "Haiti", "code": "HT", "iso3Code": "HTI", "dial_code": "+509"},
  {"name": "Honduras", "code": "HN", "iso3Code": "HND", "dial_code": "+504"},
  {"name": "Hong Kong", "code": "HK", "iso3Code": "HKG", "dial_code": "+852"},
  {"name": "Hungary", "code": "HU", "iso3Code": "HUN", "dial_code": "+36"},
  {"name": "Iceland", "code": "IS", "iso3Code": "ISL", "dial_code": "+354"},
  {"name": "India", "code": "IN", "iso3Code": "IND", "dial_code": "+91"},
  {"name": "Indonesia", "code": "ID", "iso3Code": "IDN", "dial_code": "+62"},
  {"name": "Iran", "code": "IR", "iso3Code": "IRN", "dial_code": "+98"},
  {"name": "Iraq", "code": "IQ", "iso3Code": "IRQ", "dial_code": "+964"},
  {"name": "Ireland", "code": "IE", "iso3Code": "IRL", "dial_code": "+353"},
  {"name": "Israel", "code": "IL", "iso3Code": "ISR", "dial_code": "+972"},
  {"name": "Italy", "code": "IT", "iso3Code": "ITA", "dial_code": "+39"},
  {"name": "Japan", "code": "JP", "iso3Code": "JPN", "dial_code": "+81"},
  {"name": "Jordan", "code": "JO", "iso3Code": "JOR", "dial_code": "+962"},
  {"name": "Kazakhstan", "code": "KZ", "iso3Code": "KAZ", "dial_code": "+7"},
  {"name": "Kenya", "code": "KE", "iso3Code": "KEN", "dial_code": "+254"},
  {"name": "South Korea", "code": "KR", "iso3Code": "KOR", "dial_code": "+82"},
  {"name": "Kuwait", "code": "KW", "iso3Code": "KWT", "dial_code": "+965"},
  {"name": "Laos", "code": "LA", "iso3Code": "LAO", "dial_code": "+856"},
  {"name": "Latvia", "code": "LV", "iso3Code": "LVA", "dial_code": "+371"},
  {"name": "Lebanon", "code": "LB", "iso3Code": "LBN", "dial_code": "+961"},
  {"name": "Lesotho", "code": "LS", "iso3Code": "LSO", "dial_code": "+266"},
  {"name": "Liberia", "code": "LR", "iso3Code": "LBR", "dial_code": "+231"},
  {"name": "Libya", "code": "LY", "iso3Code": "LBY", "dial_code": "+218"},
  {"name": "Lithuania", "code": "LT", "iso3Code": "LTU", "dial_code": "+370"},
  {"name": "Luxembourg", "code": "LU", "iso3Code": "LUX", "dial_code": "+352"},
  {"name": "Malaysia", "code": "MY", "iso3Code": "MYS", "dial_code": "+60"},
  {"name": "Maldives", "code": "MV", "iso3Code": "MDV", "dial_code": "+960"},
  {"name": "Mexico", "code": "MX", "iso3Code": "MEX", "dial_code": "+52"},
  {"name": "Moldova", "code": "MD", "iso3Code": "MDA", "dial_code": "+373"},
  {"name": "Monaco", "code": "MC", "iso3Code": "MCO", "dial_code": "+377"},
  {"name": "Mongolia", "code": "MN", "iso3Code": "MNG", "dial_code": "+976"},
  {"name": "Montenegro", "code": "ME", "iso3Code": "MNE", "dial_code": "+382"},
  {"name": "Morocco", "code": "MA", "iso3Code": "MAR", "dial_code": "+212"},
  {"name": "Myanmar", "code": "MM", "iso3Code": "MMR", "dial_code": "+95"},
  {"name": "Nepal", "code": "NP", "iso3Code": "NPL", "dial_code": "+977"},
  {"name": "Netherlands", "code": "NL", "iso3Code": "NLD", "dial_code": "+31"},
  {"name": "New Zealand", "code": "NZ", "iso3Code": "NZL", "dial_code": "+64"},
  {"name": "Nigeria", "code": "NG", "iso3Code": "NGA", "dial_code": "+234"},
  {"name": "Norway", "code": "NO", "iso3Code": "NOR", "dial_code": "+47"},
  {"name": "Oman", "code": "OM", "iso3Code": "OMN", "dial_code": "+968"},
  {"name": "Pakistan", "code": "PK", "iso3Code": "PAK", "dial_code": "+92"},
  {"name": "Panama", "code": "PA", "iso3Code": "PAN", "dial_code": "+507"},
  {"name": "Peru", "code": "PE", "iso3Code": "PER", "dial_code": "+51"},
  {"name": "Philippines", "code": "PH", "iso3Code": "PHL", "dial_code": "+63"},
  {"name": "Poland", "code": "PL", "iso3Code": "POL", "dial_code": "+48"},
  {"name": "Portugal", "code": "PT", "iso3Code": "PRT", "dial_code": "+351"},
  {"name": "Qatar", "code": "QA", "iso3Code": "QAT", "dial_code": "+974"},
  {"name": "Romania", "code": "RO", "iso3Code": "ROU", "dial_code": "+40"},
  {"name": "Russia", "code": "RU", "iso3Code": "RUS", "dial_code": "+7"},
  {"name": "Saudi Arabia", "code": "SA", "iso3Code": "SAU", "dial_code": "+966"},
  {"name": "Singapore", "code": "SG", "iso3Code": "SGP", "dial_code": "+65"},
  {"name": "South Africa", "code": "ZA", "iso3Code": "ZAF", "dial_code": "+27"},
  {"name": "Spain", "code": "ES", "iso3Code": "ESP", "dial_code": "+34"},
  {"name": "Sri Lanka", "code": "LK", "iso3Code": "LKA", "dial_code": "+94"},
  {"name": "Sweden", "code": "SE", "iso3Code": "SWE", "dial_code": "+46"},
  {"name": "Switzerland", "code": "CH", "iso3Code": "CHE", "dial_code": "+41"},
  {"name": "Thailand", "code": "TH", "iso3Code": "THA", "dial_code": "+66"},
  {"name": "Turkey", "code": "TR", "iso3Code": "TUR", "dial_code": "+90"},
  {"name": "Ukraine", "code": "UA", "iso3Code": "UKR", "dial_code": "+380"},
  {"name": "United Arab Emirates", "code": "AE", "iso3Code": "ARE", "dial_code": "+971"},
  {"name": "United Kingdom", "code": "GB", "iso3Code": "GBR", "dial_code": "+44"},
  {"name": "United States", "code": "US", "iso3Code": "USA", "dial_code": "+1"},
  {"name": "Vietnam", "code": "VN", "iso3Code": "VNM", "dial_code": "+84"},
  {"name": "Zambia", "code": "ZM", "iso3Code": "ZMB", "dial_code": "+260"},
  {"name": "Zimbabwe", "code": "ZW", "iso3Code": "ZWE", "dial_code": "+263"}
];

// Transform the new structure to maintain backward compatibility
export const countries: any[] = codes.map(item => ({
  country: `(${item.dial_code}) ${item.name}`,
  code: item.dial_code,
  iso: item.code,
  name: item.name
}));

/**
 * Get country code display string based on dial code and country name
 * This handles cases where multiple countries share the same dial code (e.g., +1 for USA, Canada, Dominican Republic)
 * @param dialCode - The dial code (e.g., "+1")
 * @param countryName - The country name (e.g., "United States")
 * @returns Formatted country code string like "(+1) United States" or just dial code if country not found
 */
export function getCountryCodeDisplay(dialCode: string, countryName?: string): string {
  if (!dialCode) return '';
  
  // If country name is provided, find the matching country
  if (countryName) {
    const matchingCountry = codes.find(
      c => c.dial_code === dialCode && c.name === countryName
    );
    if (matchingCountry) {
      return `(${matchingCountry.dial_code}) ${matchingCountry.name}`;
    }
  }
  
  // If no country name or no match found, check if multiple countries share this dial code
  const countriesWithSameCode = codes.filter(c => c.dial_code === dialCode);
  
  if (countriesWithSameCode.length > 1) {
    // Multiple countries share this code, but we don't have country name
    // Return just the dial code to avoid showing wrong country
    return dialCode;
  } else if (countriesWithSameCode.length === 1) {
    // Only one country has this code, safe to show it
    return `(${countriesWithSameCode[0].dial_code}) ${countriesWithSameCode[0].name}`;
  }
  
  // Fallback: just return the dial code
  return dialCode;
}

/**
 * Find country object by dial code and country name
 * This ensures we get the correct country when multiple countries share the same dial code
 * @param dialCode - The dial code (e.g., "+1")
 * @param countryName - The country name (e.g., "United States")
 * @returns Country object from countries array or undefined
 */
export function findCountryByCodeAndName(dialCode: string, countryName?: string): any {
  if (!dialCode) return undefined;
  
  // If country name is provided, find exact match
  if (countryName) {
    const matchingCountry = countries.find(
      c => c.code === dialCode && c.name === countryName
    );
    if (matchingCountry) {
      return matchingCountry;
    }
  }
  
  // If no country name or no match, check if only one country has this dial code
  const countriesWithSameCode = countries.filter(c => c.code === dialCode);
  
  if (countriesWithSameCode.length === 1) {
    return countriesWithSameCode[0];
  }
  
  // Multiple countries share this code but no country name provided
  // Return undefined to avoid wrong selection
  return undefined;
}